
  .responsive2284599289__root.Tooltip3943902061__root {
    padding: 16px;
    box-shadow: 0px 0px 12px rgba(0, 6, 54, 0.2);
    border-radius: 4px;
    max-width: 180px;
    min-width: 40px;
  }

  .responsive2284599289__root.Tooltip3943902061__root[data-popper-placement^='top']::before {
    height: calc(100% + 6px);
  }

  .responsive2284599289__root.Tooltip3943902061__root[data-popper-placement^='bottom']::before {
    height: calc(100% + 6px);
  }

  .responsive2284599289__root.Tooltip3943902061__root[data-popper-placement^='left']::before {
    width: calc(100% + 6px);
  }

  .responsive2284599289__root.Tooltip3943902061__root[data-popper-placement^='right']::before {
    width: calc(100% + 6px);
  }

/* st-namespace-reference="../../../../src/atoms/Tooltip/Tooltip.responsive.st.css" */